import { ref } from 'vue';

const getReviews = () => {
    const review_error = ref(null);
    const reviews = ref(null);

    const loadReviews = async ( monitor_others, view_locations) => {
        var params = [];
        params.push(['monitor_others',monitor_others]);
        params.push(['view_locations', view_locations]);
        
        try {
            let data = await fetch("/api/reviews?" + new URLSearchParams(params));

            //console.log("data oimapp: " ,data);
            if (!data.ok) {
                throw Error("Can't load data");
            }

            reviews.value = await data.json();
            //console.log("reviews: ", reviews.value);
            
        } catch (err) {
            review_error.value = err.message;
        }
    };
     
    return { reviews, review_error, loadReviews};
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export default getReviews;
